export type ContentDataType = {
  number: string
  title: string
  subtitle1: string | null
  subtitle2: string | null
  hasLinks: boolean
}

export const contentData: ContentDataType[] = [
  {
    number: '01',
    title:
      'Describe inputs, outputs, and common logic that you want to work across multiple apps.',
    subtitle1: null,
    subtitle2: null,
    hasLinks: true,
  },
  {
    number: '02',
    title: 'Apply universal integration to all the relevant apps',
    subtitle1: null,
    subtitle2: null,
    hasLinks: true,
  },
  {
    number: '03',
    title: 'Customize integrations for individual customers if necessary',
    subtitle1:
      'Each customer can have custom parameters, field mappings, or execution paths for each of the integrations within limits defined by you.',
    subtitle2: null,
    hasLinks: false,
  },
]
